import config from 'config';
import { $axios } from './http-client';
import {
  sampleExamBody,
  sampleExamListItem,
  sampleResult,
} from '../mocks/sample-exam';

// In mock mode, resolve with fixtures instead of hitting the backend.
const mock = (value) => Promise.resolve(value);

export const fetchExams = (params) => {
  if (config.useMock) {
    return mock({ items: [sampleExamListItem], total: 1 });
  }
  return $axios
    .get('/ielts/exam', {
      params: {
        perPage: params?.perPage || 20,
        page: params?.page || 1,
      },
    })
    .then((res) => res.data.data);
};

export const fetchExamById = (examId) => {
  if (config.useMock) {
    return mock({ id: Number(examId), examBody: sampleExamBody });
  }
  return $axios
    .get(`/ielts/exam/${examId}`)
    .then((res) => res.data.data);
};

export const submitExam = (data) => {
  if (config.useMock) {
    // Pretend the backend scored L/R and stored W/S as pending.
    return mock({ examResultId: sampleResult.id, ...data });
  }
  return $axios
    .post('/ielts/examResult', data)
    .then((res) => res.data.data);
};

export const fetchExamResults = (params) => {
  if (config.useMock) {
    return mock({ items: [{ ...sampleResult }], total: 1 });
  }
  return $axios
    .get('/ielts/examResults', {
      params: {
        perPage: params?.perPage || 10,
        page: params?.page || 1,
        sort: params?.sortBy || '-testedAt',
      },
    })
    .then((res) => res.data.data);
};

export const fetchExamResultById = (resultId) => {
  if (config.useMock) {
    return mock({ ...sampleResult, id: Number(resultId) });
  }
  return $axios
    .get(`/ielts/examResult/${resultId}`)
    .then((res) => res.data.data);
};

/**
 * Upload a Speaking recording blob; returns the stored URL to embed in the
 * submit payload. (Backend: POST /ielts/upload — Phase 3.)
 */
export const uploadSpeakingAudio = ({ examId, mark, blob }) => {
  const form = new FormData();
  form.append('examId', examId);
  form.append('mark', mark);
  form.append('file', blob);
  return $axios
    .post('/ielts/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => res.data.data?.url);
};
